$(function(){

  // スムーズスクロール
  // $('a[href^="#"]').click(function () {
  //   var speed = 400;
  //   var href = $(this).attr("href");
  //   var target = $(href == "#" || href == "" ? "html" : href);
  //   var position = target.offset().top;
  //   $("body,html").animate({ scrollTop: position }, speed, "swing");
  //   return false;
  // });

  //TOPページFVスライダー
  const swiper = new Swiper(".swiper", {
    loop: true,
    effect: 'fade',
    speed: 2000,
    autoplay: {
      delay: 3000,
    },
    allowTouchMove: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });

  // 外部リンクは別タブで開く
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
     links[i].target = '_blank';
     links[i].rel = 'noreferrer noopener';
    }
  }

});
